import {InjectionToken, Type} from "@angular/core";

export const FELLO_JOURNEY_TASK_ID = new InjectionToken<string>("FELLO_JOURNEY_TASK_ID");
export const FELLO_JOURNEY_TASK_SCREEN_MAPPING = new InjectionToken<Record<string, Type<unknown>>>("FELLO_JOURNEY_TASK_MAPPING");
